export const fromThemeProps = name => props => props.theme[name];



// WEBPACK FOOTER //
// ./src/helpers/utilities.js